<template>
  <v-row>
    <v-col cols="12" sm="12" md="8">
      <v-card>
        <poll-form v-if="poll" :poll="poll" :answered="answered" :isEmbedded="false"
          @submitted="answered = true"></poll-form>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { onMounted, ref } from "@vue/composition-api";
import api from "@/api/";
import pollForm from "@/components/polls/poll_form.vue";
import useAuth from "@/useAuth";
import router from "@/router";

export default {
  props: ["id"],
  components: {
    pollForm,
  },
  setup(props) {
    const { user } = useAuth();
    const poll = ref(null);
    const answered = ref(false);

    const fetchPoll = async (id) => {
      const pollResponse = await api.getPoll(id);

      if (pollResponse.ok) {

        poll.value = pollResponse.data;

        if (poll.value.allow_multiple_answers == false) {
          const answerResponse = await api.getUserPollAnswer(id);
          if (answerResponse.ok) {
            answered.value = true;
          }
        }
      } else {
        alert(pollResponse.error);
      }
    };

    onMounted(() => {
      if (user.value.read_only) {
        router.replace('/home');
      }
      else if (props.id) {
        fetchPoll(props.id);
      }
    });

    return {
      poll,
      answered,
    };
  },
};
</script>

<style></style>